import React, { useState } from 'react'
import { RecipeOptionsIngredients } from '@library/recipe-customisations'
import { RecipeUUID } from '@library/menu-service'
import {
  Box,
  Button,
  Color,
  Display,
  FlexDirection,
  Text,
  JustifyContent,
  Spinner,
  AlignItems,
} from '@gousto-internal/citrus-react'
import { AlternativeOptions } from '../../../model/alternativeOptions/alternativeOptions'

const formatSurcharge = (value: number) => {
  if (value === 0) return `£${value}`

  return value < 0 ? `Save £${value}` : `+£${value}`
}

type Props = {
  recipeUuid: RecipeUUID
  alternativeOptions: AlternativeOptions
  isLoading: boolean
  reachedLimit: boolean
  onSelectRecipe: (id: RecipeUUID) => void
  addRecipeToBasket: (id: RecipeUUID) => void
}

export function IngredientAlternativeOptions({
  recipeUuid,
  alternativeOptions,
  isLoading,
  reachedLimit,
  onSelectRecipe,
  addRecipeToBasket,
}: Props) {
  const [selectedRecipeId, setSelectedRecipeId] = useState<RecipeUUID>(recipeUuid)

  const onChangeSelection = (id: RecipeUUID) => {
    onSelectRecipe(id)
    setSelectedRecipeId(id)
  }

  if (isLoading) {
    return (
      <Box width="100%" display={Display.Flex} justifyContent={JustifyContent.Center} paddingV={5}>
        <Spinner color={Color.ColdGrey_900} size={6} />
      </Box>
    )
  }

  const currentlySelectedRecipe = alternativeOptions?.options?.find(
    (option) => option.recipe.id === selectedRecipeId,
  )

  const formattedSurcharge = currentlySelectedRecipe?.surcharge
    ? formatSurcharge(currentlySelectedRecipe?.surcharge)
    : null

  const disabled = currentlySelectedRecipe?.isOutOfStock || reachedLimit

  const buttonText = currentlySelectedRecipe?.isOutOfStock ? 'Sold out' : 'Add recipe'

  const handleAdd = () => {
    if (!disabled) {
      addRecipeToBasket(selectedRecipeId)
    }
  }

  return (
    <Box>
      <Box width="100%">
        <RecipeOptionsIngredients
          recipeUuid={selectedRecipeId}
          options={alternativeOptions.options}
          ingredientSlots={alternativeOptions.ingredientSlots}
          onChangeSelection={onChangeSelection}
        />
      </Box>
      <Button onClick={() => handleAdd()} disabled={disabled} width="100%">
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Row}
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.Center}
          gap={2}
        >
          {buttonText}
          {(currentlySelectedRecipe?.surcharge || 0) > 0 ? (
            <Box style={{ background: '#f3c435', padding: '1px 3px' }}>
              <Text style={{ fontSize: '12px', fontWeight: 'bold' }} color={Color.ColdGrey_900}>
                {formattedSurcharge} per serving
              </Text>
            </Box>
          ) : null}
        </Box>
      </Button>
    </Box>
  )
}
